import dynamic from 'next/dynamic'
import styled from '@emotion/styled'
import { useMemo } from 'react'
import { MapExplorerSidebar } from 'src/views/map-explorer/sidebar'
import { useParsedRouter } from 'src/layout/hooks/use-parsed-router'
import { ContentLoader } from 'src/layout/content-loader'
import { MapMock } from 'src/components/MapMock'
import { CustomCompanyLogo } from 'src/components/sidebar-panels/custom-company-logo'

const MainContentContainer = styled.div`
  flex: 1 1 auto;
  display: flex;
  position: relative;
  height: 100vh;
`

const MapExplorerMap = dynamic(() => import('src/views/map-explorer/map'), {
  ssr: false,
  loading: () => <ContentLoader />,
})

const InsightsContent = dynamic(() => import('src/views/map-explorer/insights'), {
  ssr: false,
})

export const MapExplorer = () => {
  const { router } = useParsedRouter()

  const isInsightsPage = useMemo(() => {
    return router.asPath.includes('insights')
  }, [router.asPath])

  return (
    <MainContentContainer>
      {/* <Sidebar /> */}
      <MapExplorerSidebar footer={<CustomCompanyLogo />} />
      <InsightsContent />
      {!isInsightsPage ? <MapExplorerMap /> : <MapMock />}
    </MainContentContainer>
  )
}
